import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { ENGLISH_LANG } from 'configs/constants';
import { initReactI18next } from 'react-i18next';

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    fallbackLng: ENGLISH_LANG,
    backend: {
      loadPath: 'locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'no-store',
      },
    },
    ns: ['common', 'notifications', 'receipt'],
    defaultNS: 'common',
    debug: false,
    parseMissingKeyHandler: (key) => {
      console.warn(`Key "${key}" not found.`);

      return key;
    },
  });

export default i18n;
